import { GasCylinderIcon } from './GasCylinderIcon';

/**
 * author: Simran
 * id 7CEC48C5-3A70-4BA2-9FB8-A383387DC4A1
 * name gas-cylinder
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gas-cylinder.svg
 * tags
 */
export const OxygenTankIcon = GasCylinderIcon;
export default OxygenTankIcon